module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-500.9443df45.woff";